import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';
import { useLocale } from '../../../hooks/index';

export type ResendInvitationProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
};

const ResendInvitationModal: FC<ResendInvitationProps> = ({ isOpen, onDismiss, onSuccess }) => {
  const { messagesLocale } = useLocale();
  return (
    <Modal
      description={<AppFormattedMessage id="GENERATING_INVITATION_AGAIN_WILL_VOID" />}
      dismissButtonContent={<AppFormattedMessage id="NO_KEEP_4" />}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onSuccess={onSuccess}
      successButtonContent={<AppFormattedMessage id="YES_RESEND" />}
      title={messagesLocale['RESEND_INVITATION'] + '?'}
    />
  );
};

export default ResendInvitationModal;
